export function getUploadUrl(path: string) {
  if (path.startsWith('/')) {
    path = path.substring(1);
  }

  return `${process.env.VITE_UPLOAD_URL}${path}`;
}
